export const RUT_REGEX = /^[0-9]{1,8}-[0-9Kk]$/;

/**
 * Calcula el dígito verificador de un RUT utilizando el algoritmo Modulo 11
 * @param {string|number} rut - El RUT sin el dígito verificador
 * @returns {string} - El dígito verificador calculado
 */
const calculateVerificationDigit = (rut) => {
  rut = rut.toString(); // Convertir a cadena en caso de ser un número

  let multiplier = 2;
  let sum = 0;

  // Itera sobre la parte numérica del RUT de derecha a izquierda
  for (let i = rut.length - 1; i >= 0; i -= 1) {
    const digit = parseInt(rut.charAt(i), 10);
    sum += digit * multiplier;
    multiplier = multiplier % 7 === 0 ? 2 : multiplier + 1;
  }

  const dv = 11 - (sum % 11);

  if (dv === 11) {
    return '0';
  }
  if (dv === 10) {
    return 'K';
  }
  return dv.toString();
};

/**
 * Valida un RUT chileno (Rol Único Tributario) utilizando el algoritmo Modulo 11
 * @param {string|number} rut - El RUT a validar. Puede ser proporcionado como número o string (con o sin puntos y guiones).
 * @returns {boolean} - Indica si el RUT es válido.
 */
export const isValidRut = (rut) => {
  // Limpia el RUT eliminando puntos y guiones
  const cleanedRut = rut.toString().replace(/[.-]/g, '');

  // Verifica si el RUT es demasiado corto
  if (cleanedRut.length < 2) {
    return false;
  }

  // Divide el RUT en la parte numérica y el dígito verificador
  const numericPart = cleanedRut.slice(0, -1);
  const dv = cleanedRut.slice(-1).toUpperCase();

  // Compara el dígito verificador calculado con el proporcionado
  const calculatedDV = calculateVerificationDigit(numericPart);
  return calculatedDV === dv;
};
